import { Injectable } from '@angular/core';


interface AccessRules{
    panel_list:any;
    performance_panel:any;
    project:any;
    project_list:any;
    recruiter:any;
    side_drawer:any;
    study:any;
    study_list:any;
    study_recuiter:any;
    sub_side_drawer:any;
    visibility_control:any;
  }
  
  interface AccessRoles{
    access_rules:AccessRules;
    access_type:string;
    id:string;
    name:string;
    org_id:string;
    org_name:string;
    super:boolean;
  }

@Injectable({
    providedIn:'root'
})
export class RoleService{

    accessRules:AccessRoles;

    constructor(){
        this.accessRules = JSON.parse(localStorage.getItem('access'));
    }
    getRoles():AccessRoles{
        return this.accessRules;
    }
    setRoles(roles:any): void{
        this.accessRules = roles;
    }
}